module.exports = __webpack_public_path__ + "static/award_gia-243d12dcc25f290d0df28cb42adbd2b8.png";